import { createSelector, createFeatureSelector, } from '@ngrx/store';
import { DialogState } from './dialog.model';
import { FEATURE_NAME } from './dialog.constant';

export const selectVshcDialogSlice = createFeatureSelector<DialogState>(FEATURE_NAME);

export const selectVshcDialogState = (key: string) => createSelector(
  selectVshcDialogSlice,
  (slice) => slice ? slice.keys[key] || { state: false } : { state: false }
);
